import React from 'react';

export interface EmptyStateProps {
  message: string;
  icon?: React.ReactNode;
  className?: string;
  title?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ message, icon, title, action, className = '' }) => {
  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 ${className}`}>
      {icon && <div className="mb-4 text-slate-500">{icon}</div>}
      {title && <h2 className="mb-2 text-lg font-semibold text-white">{title}</h2>}
      <p className="text-slate-400 text-center">{message}</p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
};
